import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TableProComponent } from '../../../../../components/table-pro/table-pro.component';
import { TableProConfig } from '../../../../../components/table-pro/core/table-pro.model';

@Component({
  selector: 'demo-table-pro',
  standalone: true,
  imports: [CommonModule, TableProComponent],
  templateUrl: './demo-table-pro.component.html',
  styleUrl: './demo-table-pro.component.scss',
})
export class DemoTableProComponent {
  tableConfig: TableProConfig = {
    itemsPerPage: 5,
    itemsPerPageConfig: [3, 5, 10, 15, 20],
    classContainer: 'm-t-20',
    collumnConfig: [
      { id: 'Name', index: 0, type: 'text' },
      { id: 'Age', index: 1, type: 'number' },
      { id: 'Address', index: 2, type: 'text' },
      { id: 'Phone', index: 3, type: 'text', isOrdenable: false },
      { id: 'Document', index: 4, type: 'text', isOrdenable: false },
      { id: 'Status', index: 5, type: 'boolean' },
      { id: 'Date', index: 6, type: 'date' },
      { id: 'TotalValue', index: 7, type: 'number' },
    ],
  };

  users = [
    {
      name: 'João da Silva',
      age: '23',
      address: 'Rua das Palmeiras, 149',
      phone: '41 6548-5545',
      document: '546.654.684-87',
      isOk: true,
      date: new Date(+new Date() - Math.floor(Math.random() * 10000000000)),
      totalValue: {
        formattedValue: 'R$ 1.000,00',
        value: 1000,
      },
    },
    {
      name: 'Maria Oliveira',
      age: '1',
      address: 'Avenida Brasil, 2020',
      phone: '21 9564-3321',
      document: '123.456.789-00',
      isOk: true,
      date: new Date(+new Date() - Math.floor(Math.random() * 10000000000)),
      totalValue: {
        formattedValue: 'R$ 1.500,30',
        value: 1500.3,
      },
    },
    {
      name: 'Carlos Pereira',
      age: '10',
      address: 'Rua das Laranjeiras, 300',
      phone: '11 9856-7854',
      document: '987.654.321-12',
      isOk: true,
      date: new Date('12-01-2025'),
      totalValue: {
        formattedValue: 'R$ 1.800,00',
        value: 1800,
      },
    },
    {
      name: 'Ana Souza',
      age: '2',
      address: 'Avenida Atlantica, 1234',
      phone: '31 9785-4123',
      document: '321.654.987-54',
      isOk: true,
      date: new Date(+new Date() - Math.floor(Math.random() * 10000000000)),
      totalValue: {
        formattedValue: 'R$ 2.345,00',
        value: 2345,
      },
    },
    {
      name: 'Fernanda Costa',
      age: '03',
      address: 'Rua das Acácias, 456',
      phone: '71 9123-4567',
      document: '789.456.123-98',
      isOk: true,
      date: new Date(+new Date() - Math.floor(Math.random() * 10000000000)),
      totalValue: {
        formattedValue: 'R$ 5.600,00',
        value: 5600,
      },
    },
    {
      name: 'Pedro Martins',
      age: '45',
      address: 'Rua das Flores, 567',
      phone: '51 6547-1234',
      document: '654.321.123-45',
      isOk: false,
      date: new Date(+new Date() - Math.floor(Math.random() * 10000000000)),
      totalValue: {
        formattedValue: 'R$ 10.450,20',
        value: 10450.2,
      },
    },
    {
      name: 'Lucas Almeida',
      age: '30',
      address: 'Rua dos Pinheiros, 789',
      phone: '81 9675-7841',
      document: '456.789.123-65',
      isOk: false,
      date: new Date(+new Date() - Math.floor(Math.random() * 10000000000)),
      totalValue: {
        formattedValue: 'R$ 3.540,15',
        value: 3540.15,
      },
    },
  ];
}
